import { render, staticRenderFns } from "./PersonPersonalDataComponent.vue?vue&type=template&id=367d6320"
import script from "./PersonPersonalDataComponent.vue?vue&type=script&lang=js"
export * from "./PersonPersonalDataComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports